import styles from '../../styles/bonus.less';
import { useCallback } from 'react';
import { openPageNative } from '@/utils/bridge';
import { reportClick } from '@/utils/report';
import { jumpToPageByH5 } from '@/utils/fn';
import { connect } from 'dva';

// 跳转链接拼接前缀
export const LINK_PREFIX_MAP = {
  // H5链接APP内打开
  1: 'page:web_view?url=',
  // H5链接APP外打开
  2: 'intent:',
  // 原生链接
  3: 'android:',
};

// 加成卡广告位模块
const RecommendBonusCard = (
  {
    rights: { bonusCardAdList }
  }) => {
  const { id, jumpUrl, linkType } = bonusCardAdList?.[0];

  const handleClick = useCallback(customerGroup => {
    openPageNative({
      url: `${LINK_PREFIX_MAP[linkType]}${encodeURIComponent(jumpUrl)}`,
    });
    reportClick({
      page_name: "bonus_card",
      button_name: 'BonusCardAdvertisement',
      ads_id: id,
    });
  }, []);

  return (
    <div className={styles.recommendCard} onClick={handleClick}>
      <img src={bonusCardAdList?.[0].imgUrl} />
    </div>
  )
}

export default connect(({ rights }) => ({
  rights,
}))(RecommendBonusCard);
